module.exports = __webpack_public_path__ + "static/img/homes5.eb1e98e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/home/homes5.png
// module id = NOZF
// module chunks = 2